// Build-time settings (VITE_* in web/.env; see .env.example). Nothing secret may live here:
// every VITE_* value ends up in the browser bundle.

const base = import.meta.env.BASE_URL; // "/" or "/v1-meet/" (VITE_BASE_PATH at build time)

export const APP_CONFIG = {
  /** The path the app is served under. */
  basePath: base,
  /** The meeting API's token URL, absolute, on its own host: never through the site's
   *  /v1-meet rewrite (ADR 002). vite.config.ts validates it and fills in the dev default. */
  tokenUrl: import.meta.env.VITE_TOKEN_URL ?? '',
  /** The tenant (customer account) this build serves (O267: one tenant id from day one). */
  tenant: import.meta.env.VITE_TENANT || 'versiyonbir',
} as const;
